import { clampVerticalTexts } from '@/functions';
import { owl } from 'commonComponents/image-visor/image-visor';

export default () => {
  $(document).ready(function () {
    if ($(".gallery-page").length > 0) {
      openLightBoxFromGetUrl();
    }
  });

  $('.gallery-item .gallery-item-img, .gallery-item .control-buttons .zoom-icon').off('click').click(function(){
    const photoSelected = $(this).data('id');
    window.dataLayer.push({
      event: 'click_image',
      eventData: {
        im_location: 'secundaria_' + photoSelected,
        content_id: window.appInfo?.contentId ?? undefined
      }
    });

    window.location.hash = `#foto${photoSelected}`;

    const cmpImageVisor = $('.gallery-header .cmp-image-visor');
    if (!cmpImageVisor.length) {
      return;
    }

    cmpImageVisor.show();

    owl.trigger('to.owl.carousel', photoSelected - 1);

    $('body').css("overflow-y", "hidden");

    setTimeout(function(){
      clampVerticalTexts('img');
    }, 500);
  });

  function openLightBoxFromGetUrl() {
    let id = window.location.hash;
    if (id === undefined
      || id === "") {
      return;
    }
    id = id.replace('#','');
    document.getElementById(id).click();
  }
}
